// SupportInfo.jsx
import React from "react";
import phoneIcon from "common-ui-components/components/icons/phone.svg";
import mailIcon from "common-ui-components/components/icons/mail.svg";
import fileIcon from "../icons/file.svg";
import faqIcon from "../icons/faq.svg";
import videoIcon from "../icons/video.svg";
import { links } from "HelpLinks";
// import chevronIcon from "common-ui-components/components/icons/chevron-right.svg";
import styles from "./SupportInfo.module.css";

const resources = [
  {
    icon: fileIcon,
    title: "Help docs",
    description: "Setup guides and how-tos",
    url: links.help,
  },
  {
    icon: faqIcon,
    title: "FAQs",
    description: "Answers to common questions",
    url: links.faq,
  },
  {
    icon: videoIcon,
    title: "Videos",
    description: "Short walkthroughs of key features",
    url: links.video,
  },
];

const SupportInfo = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerText}>
          <h3 className={styles.title}>We're here to help</h3>
          <p className={styles.description}>
            Reach out directly, or send a request and our support team will pick
            it up.
          </p>
        </div>
      </div>

      <hr className={styles.divider} />

      <section>
        <h4 className={styles.sectionLabel}>Reach us directly</h4>

        <a href="tel:+14159121352" className={styles.contactCard}>
          <span className={styles.iconWrapper}>
            <img height={20} width={20} src={phoneIcon} alt="" />
          </span>
          <span className={styles.contactText}>
            <span className={styles.contactLabel}>Phone</span>
            <span className={styles.contactValue}>+1 415 912 1352</span>
          </span>
        </a>

        <a href="mailto:support@zecurit.com" className={styles.contactCard}>
          <span className={styles.iconWrapper}>
            <img height={20} width={20} src={mailIcon} alt="" />
          </span>
          <span className={styles.contactText}>
            <span className={styles.contactLabel}>Email</span>
            <span className={styles.contactValue}>support@zecurit.com</span>
          </span>
        </a>
      </section>

      <hr className={styles.divider} />

      <section>
        <h4 className={styles.sectionLabel}>Resources</h4>

        <div className={styles.resourceList}>
          {resources.map(({ icon, title, description, url }) => (
            <div key={title} className={styles.resourceRow}>
              <span className={styles.iconWrapper}>
                <img height={20} width={20} src={icon} alt="" />
              </span>
              <span className={styles.resourceText}>
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className={styles.resourceTitle}
                >
                  {title}
                </a>
                <span className={styles.resourceDescription}>
                  {description}
                </span>
              </span>
              <span className={styles.chevron} aria-hidden="true">
                &rsaquo;
              </span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default SupportInfo;
